import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
const WITHOUT = ["Improvisás cada clase", "Horas perdidas planificando", "Sin método por edad", "Conflictos con padres", "Más lesiones evitables", "Estrés y desgaste"];
const WITH = ["Todo el año resuelto", "Sesiones listas para usar", "Método etapa por etapa", "Comunicación bajo control", "Prevención por edad", "Tranquilidad y foco"];
export function ComparisonTable() {
  return <section className="px-4 py-6" data-id="element-52" data-mp="3iae541l2jp80">
      <h2 className="mb-4 text-center text-xl font-black leading-tight text-white" data-id="element-53" data-mp="3me3w0xp7uiw7">
        Sin Profe Fútbol Resuelto vs Con Profe Fútbol Resuelto
      </h2>

      <div className="grid grid-cols-2 gap-2.5" data-id="element-54" data-mp="38gf6vdo48plc">
        <div className="rounded-xl border border-red-300/30 bg-[#3a1414]/85 p-3 backdrop-blur-sm" data-id="element-55" data-mp="3dc2vnryorgqb">
          <p className="mb-2 text-center text-xs font-black uppercase text-red-300" data-id="element-56" data-mp="1wxurfdhs9u3h">
            Sin el sistema
          </p>
          <ul className="space-y-2" data-id="element-57" data-mp="21zaaj00ehqj8">
            {WITHOUT.map(t => <li key={t} className="flex items-start gap-1.5" data-id="element-58" data-mp="2dy6ydsexgnix">
                <XIcon className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-red-400" data-id="element-59" data-mp="29w3kyy8p78v0" />
                <span className="text-[13px] leading-tight text-red-100" data-id="element-60" data-mp="2nvle1pt118a6">{t}</span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-xl border border-[#8bc34a]/40 bg-[#0f2c4a]/90 p-3 backdrop-blur-sm" data-id="element-61" data-mp="2ivguts0qhzg9">
          <p className="mb-2 text-center text-xs font-black uppercase text-[#8bc34a]" data-id="element-62" data-mp="2wv881qjffbt7">
            Con el sistema
          </p>
          <ul className="space-y-2" data-id="element-63" data-mp="2sufwurqzuwua">
            {WITH.map(t => <li key={t} className="flex items-start gap-1.5" data-id="element-64" data-mp="36l1iupbqvmwe">
                <CheckIcon className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-[#8bc34a]" data-id="element-65" data-mp="31n9qju76tyro" />
                <span className="text-[13px] leading-tight text-white" data-id="element-66" data-mp="3gka7r3rr6bbw">{t}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}